<template>
  <div>
    <v-card class="my-1">
      <v-card-title>EPF Form A / EIS Import / SOCSO Import / CP39 / RHB Import</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="payrollPeriod"
            v-validate="'required'"
            label="Payroll Period"
            item-text="payroll_date"
            item-value="id"
            :items="payrollPeriods"
            clearable
            hide-selected
            :error-messages="errors.collect('payrollPeriod')"
            data-vv-name="payrollPeriod"  
            data-vv-as="payroll period"
          />
        </v-col>

        <v-col>
          <v-autocomplete
            v-model="reportType"
            v-validate="'required'"

            label="Form/Report Types"   
            :items="reportList"
            :error-messages="errors.collect('reportType')"
            data-vv-name="reportType"  
            data-vv-as="report type"
            item-text="value"
            item-value="id"
          />
        </v-col>
       
        <v-col />

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="progressing" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                :loading="progressing"
                color="primary"
                @click="generate"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row> 
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriods: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        reportType: null,
        reportList: [
          { id: 'EPF', value: 'EPF Form A' },
          { id: 'EIS', value: 'EIS Import Text' },
          { id: 'SOCSO', value: 'SOCSO Import Text' },
          { id: 'CP39', value: 'MTD Text File (CP39)' },
          { id: 'EPF_RHB', value: 'EPF Import Excel (RHB)' },
          { id: 'SOCSO_RHB', value: 'SOCSO Import Excel (RHB)' },
          { id: 'EIS_RHB', value: 'EIS Import Excel (RHB)' },
        ],
        progressing: false,
        progressbar: 0,
        payrollPeriod: null,
      }
    },
    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            if (this.reportType) {
              if (this.reportType === 'EPF') {
                this.generateEpfFormA()
              } else if (this.reportType === 'EIS') {
                this.generateEisImportText()
              } else if (this.reportType === 'SOCSO') {
                this.generateSocosImportText()
              } else if (this.reportType === 'CP39') {
                this.generateCp39ImportText()
              } else if (this.reportType === 'EPF_RHB' || this.reportType === 'SOCSO_RHB' || this.reportType === 'EIS_RHB') {
                this.generateEpfSocsoEisImportExcelRhb(this.reportType)
              }
            }
          })
      },

      generateEpfFormA () {
        this.$api.payrollCycleTransactions().epfFormA(this.payrollPeriod, {
          onDownloadProgress: (progressEvent) => {
            this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
          },
        })
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'EpfFormA.zip')  
            link.click()

            this.progressing = false
            this.progressbar = 0

            this.$snack({ message: 'Report downloaded successfully' })
          })
      },
      generateEisImportText () {
        this.$api.payrollCycleTransactions().eisImportText(this.payrollPeriod, {
          onDownloadProgress: (progressEvent) => {
            this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
          },
        })
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'EisImport.zip') 
            link.click()

            this.progressing = false
            this.progressbar = 0

            this.$snack({ message: 'Report downloaded successfully' })
          })
      },
      generateSocosImportText () {
        this.$api.payrollCycleTransactions().socsoImportText(this.payrollPeriod, {
          onDownloadProgress: (progressEvent) => {
            this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
          },
        })
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'SocsoImport.zip') 
            link.click()

            this.progressing = false
            this.progressbar = 0

            this.$snack({ message: 'Report downloaded successfully' })
          })
      },
      generateCp39ImportText () {
        this.$api.payrollCycleTransactions().cp39ImportText(this.payrollPeriod, {
          onDownloadProgress: (progressEvent) => {
            this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
          },
        })
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'CP39.zip') 
            link.click()

            this.progressing = false
            this.progressbar = 0

            this.$snack({ message: 'Report downloaded successfully' })
          })
          .catch(error => {
            this.progressing = false
            if (error.response.status === 400) {
              this.$snack({ color: 'error', message: 'Data not found' })
            }
          })
      },
      generateEpfSocsoEisImportExcelRhb (reportType) {
        this.$api.payrollCycleTransactions().epfSocsoEisRhb(this.payrollPeriod, { 'report_type': reportType }, {
          onDownloadProgress: (progressEvent) => {
            this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
          },
        })
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/zip' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', reportType + '.zip')
            link.click()

            this.progressing = false
            this.progressbar = 0

            this.$snack({ message: 'Report downloaded successfully' })
          })
          .catch(error => {
            this.progressing = false
            if (error.response.status === 400) {
              this.$snack({ color: 'error', message: 'No company with default bank is RHB found.' })
            }
          })
      },
    },
  }
</script>
